export { default as DirtyMonitor } from './DirtyMonitor.container';
export { default as DirtyInformer } from './DirtyInformer.container';


// WEBPACK FOOTER //
// ./src/components/shared/dirty-data/index.ts